<script setup>
import {onMounted, reactive, ref, watch} from 'vue'

const props = defineProps({
    widget: Object,
    buttons: Array,
})

const page = reactive({
    fields: null,
    loading: null,
    pageSize: props.pageSize || 25,
    select: null,
})

const table = ref(null)

defineExpose({update})

onMounted(() => {
    update()
})

function update() {
    let fields = props.widget.fields || []
    page.fields = fields.map((f) => {
        return typeof f == 'string' ? {name: f} : f
    })
    if (table.value) {
        table.value.update({wait: true})
    }
}

function buttonClick() {}
function clicked() {}
</script>

<template>
    <div>
        <vu-table
            class="table-widget"
            options="dynamic,filter,toolbar"
            ref="table"
            width="100%"
            :data="widget.value"
            :fields="page.fields"
            :nodata="page.loading ? 'Loading...' : 'No Items'"
            :name="widget.subtitle"
            :pageSize="page.size"
            :pivot="widget.pivot"
            :select="page.select"
            :title="widget.subtitle"
            @click="clicked">
            <template v-slot:more="props">
                <v-btn
                    v-for="(btn, index) in buttons"
                    class="mr-2"
                    :color="index == 0 ? 'accent' : ''"
                    :variant="index > 0 ? 'outlined' : 'elevated'"
                    :key="btn"
                    @click="buttonClick(btn)">
                    {{ btn }}
                </v-btn>
            </template>
        </vu-table>
    </div>
</template>

<style lang="scss">
.table-widget {
    padding: 40px 20px 20px 20px;
    font-size: 1rem;
    .table-title {
        font-size: 1.4rem !important;
        padding-top: 5px;
    }
    .table-data {
        width: 100%;
    }
}
</style>
